import axiosApi from "./api_helper";

// Thin get/post/put/del wrappers around the shared axios instance from
// ./api_helper (base URL, credentials, CORS interceptors all live there).
// Moved out of api_helper.js so that file only owns the axios instance itself.

export async function get(url, config = {}) {
  // Allow overriding withCredentials per request
  const requestConfig = {
    ...config,
    withCredentials: config.withCredentials !== false ? true : false,
  };
  const response = await axiosApi.get(url, requestConfig);
  return response.data;
}

export async function post(url, data, config = {}) {
  // Allow overriding withCredentials per request
  const requestConfig = {
    ...config,
    withCredentials: config.withCredentials !== false ? true : false,
  };
  const response = await axiosApi.post(url, data, requestConfig);
  return response.data;
}

export async function put(url, data, config = {}) {
  // Allow overriding withCredentials per request
  const requestConfig = {
    ...config,
    withCredentials: config.withCredentials !== false ? true : false,
  };
  const response = await axiosApi.put(url, data, requestConfig);
  return response.data;
}

export async function del(url, config = {}) {
  // Allow overriding withCredentials per request
  const requestConfig = {
    ...config,
    withCredentials: config.withCredentials !== false ? true : false,
  };
  const response = await axiosApi.delete(url, requestConfig);
  return response.data;
}
